import React from 'react'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Loader2 } from 'lucide-react'

interface ConfirmationDialogProps {
  _open: boolean
  onOpenChange: (_open: boolean) => void
  title: string
  description: string
  details?: string
  confirmText?: string
  cancelText?: string
  onConfirm: () => void
  isSubmitting?: boolean
  variant?: 'default' | 'destructive'
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  _open,
  onOpenChange,
  title,
  description,
  details,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  isSubmitting = false,
  variant = 'default',
}) => {
  return (
    <Dialog open={_open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
          {details && (
            <div className="mt-2 p-3 bg-gray-100 rounded-md">
              <p className="text-sm font-medium">{details}</p>
            </div>
          )}
        </DialogHeader>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isSubmitting}
          >
            {cancelText}
          </Button>
          <Button
            variant={variant}
            onClick={onConfirm}
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Processing...
              </>
            ) : (
              confirmText
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
